import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

export const Wrapper = styled.div`
  & > div {
    background-color: #007a42;
    padding-bottom: ${primitive.$spacing1};
    padding-top: ${primitive.$spacing1};
    & > p {
      margin-top: 0px;
      margin-bottom: 0px;
      font-size: 0.75rem;
    }
  }
`;
